import {IComponentOptions, ILogService} from "angular";
import {IModalInstanceService} from "angular-ui-bootstrap";

class ApplicationDeleteAttachmentModalController {

    public modalInstance: IModalInstanceService;
    public resolve: any;
    public close: any;
    public dismiss: any;

    /* @ngInject */
    constructor(private $log: ILogService) {
    }

    public submit() {
        this.$log.info("submit()");
        this.close();
    }

    public cancel() {
        this.dismiss({$value: "cancel"});
    }
}

export const ApplicationDeleteAttachmentModalComponent: IComponentOptions = {
    bindings: {
        modalInstance: "<",
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controller: ApplicationDeleteAttachmentModalController,
    template: require("./application-delete-attachment-modal.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/application/modals/delete-attachment-modal/application-delete-attachment-modal.component.ts